import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { Trigger } from "./lazy-load.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LazyLoad = function LazyLoad(_ref) {
  var fallback = _ref.fallback,
    threshold = _ref.threshold,
    rootMargin = _ref.rootMargin,
    children = _ref.children;
  var _useInView = useInView({
      threshold: threshold,
      rootMargin: rootMargin,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [inView ? children : /*#__PURE__*/_jsx(Trigger, {
      ref: ref
    }), fallback && /*#__PURE__*/_jsx("noscript", {
      children: fallback
    })]
  });
};
LazyLoad.defaultProps = {
  children: null,
  threshold: 0,
  rootMargin: '0px',
  fallback: null
};
LazyLoad.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.element,
  threshold: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  rootMargin: PropTypes.string
};
export default /*#__PURE__*/React.memo(LazyLoad);